import { Injectable } from '@angular/core';

import { DropdownQuestion } from '../model/question-dropdown';
import { CheckboxQuestion } from '../model/question-checkbox';
import { NumerictextboxQuestion } from '../model/question-numerictextbox';
import { QuestionBase } from '../model//question-base';
import { TextboxQuestion } from '../model/question-textbox';
import { TextareaQuestion } from '../model/question-textarea';
import { DatepickerQuestion } from '../model/question-datepicker';
import { MultiselectQuestion } from '../model/question-multiselect';
import { combineLatest, of, BehaviorSubject, Observable, UnaryFunction, OperatorFunction, pipe } from 'rxjs';
import{FirebaseService } from '../services/firebase.service'
import { map, tap, switchMap, first, filter, mergeMap } from 'rxjs/operators';
import { ErrorPagesModule } from '../../../pages/error-pages/error-pages.module';

@Injectable()
export class QuestionService {
  private readonly currentModelSubject = new BehaviorSubject(null)
   currentModel$ = this.currentModelSubject.asObservable()
  private readonly currentAssetSubject = new BehaviorSubject(of(null))
  currentAsset$ = this.currentAssetSubject.asObservable().pipe(switchMap(x=>x))

  constructor(private fb:FirebaseService, ) {
   
  }
  setCurrentModel(model):void{
    this.currentModelSubject.next(model)
  }
  setCurrentAsset(valueLink,valueKey?):void{
    if(valueKey){
      this.currentAssetSubject.next(this.fb.getDocument(valueKey,valueLink).pipe(first()))
    } else{
      this.currentAssetSubject.next(of(null))
    }
  }
   filterNullish<T>(): UnaryFunction<Observable<T | null | undefined>, Observable<T>> {
    return pipe(
      filter(x => x != null) as OperatorFunction<T | null |  undefined, T>
    );
  }

  catalogueQuestions(x){
    let quest
        switch (x.type) {
          case 'dropdown':
            quest = new DropdownQuestion({...x})
              break;
          case 'textbox':
            quest = new TextboxQuestion({...x})
              break;
          case 'datepicker':
            quest = new DatepickerQuestion({...x})
              break;
          case 'numerictextbox':
            quest = new NumerictextboxQuestion({...x})
              break;
          case 'checkbox':
            quest = new CheckboxQuestion({...x})
              break;
          case 'textarea':
            quest = new TextareaQuestion({...x})
              break;
          case 'multiselect':
            quest = new MultiselectQuestion({...x})
              break;
        }
        // console.log('questiooons4',quest)
        return quest
  }
  // TODO: get from a remote source of question metadata
  getQuestions(formKey:string,formLink:string,valueLink:string,valueKey?:string) {
    console.log('get questions',formKey,formLink,valueLink,valueKey)
    let assets$
    if(valueKey){
      // this.setCurrentAsset(valueLink,valueKey)
       assets$ = this.fb.getDocument(valueKey,valueLink)
    } else{
      assets$ = of(null)
    }
    // this.fb.addDocConIdFb()
    const model$ = this.currentModel$.pipe(switchMap( m=>{
      let model
      if(m){
      console.log('modeeeel',m)
      model =  this.fb.getCollectionWhereFB('/netsolinapp/parametros/models','key',m.key).pipe(first(), map(x=>x[0])).toPromise();

    } else {
      model = of(null)
    }
    return model
    }))

    let q$:any
    switch (formLink) {
      case '/netsolinapp/parametros/forms':
        q$ = this.fb.getDocument(formKey,formLink).pipe(map((q:any)=>{
          console.log('question model',q)
         
          const questions: QuestionBase<string>[] = q.questions.map(x=>{
           
            return this.catalogueQuestions(x)
          })
          questions.sort((a, b) => a.order - b.order)
          console.log('questiooons3', questions)
          return questions
        }))
        break;
      case '/netsolinapp/parametros/models':
        q$ = this.fb.getCollectionWhereFB(formLink,'key',formKey).pipe(tap(x=>console.log('respuestatapmodel',x)),map(x=>x[0]),map((q:any)=>{
          console.log('question model',q)
         
          const questions: QuestionBase<string>[] = q.modelQuestions.map(x=>{
           
            return this.catalogueQuestions(x)
          })
          questions.sort((a, b) => a.order - b.order)
          console.log('questiooons3', questions)
          return questions
        }))
        break;
    }
   
   
   
    
    
    // return combineLatest([assets$,q$]).pipe(map((results:any) => {
    return combineLatest([assets$,q$]).pipe(map((results:any) => {
      let q:any = results[1];
      const a = results[0];
      console.log('questionasset', a)
      q.map(x=>{
        if(a){
          x.value = a[x.key] ? a[x.key]: '';
          if(x.model){
            x.modelInfo.key = a.model
          }
        }
      })

      // if(model){
       
      //   if(model.formQuestions){
      //     for (const quest of model.formQuestions) {
      //       console.log('resultadoss2',quest,model)
      //       if(quest.errors){
      //         let obj = q.find(ques => ques.key === quest.key);
      //         obj.errors = quest.errors
      //         obj.validators = quest.validators
      //       }
      //     }
      //   }
      // }

      //ciclo for a las preguntas A (deben tener el link de la pregunta), suma las promesas  a un array de promesas, antes de la suma le agrega la llave de la pregunta a la promesa
      //resolver array de promesas y juntar el resultado con las opciones de las preguntas por el campo de opciones
      console.log('resultadoss', q)
      const z =[...q]

      return z
    }), tap(x=>console.log('tapx',x))
    // ,switchMap(quest=>{
    
    //   return this.currentAsset$.pipe(map((assetval:any)=>{
    //     console.log('assetval',assetval,quest)
    //     if(!assetval){
    //       return quest
    //     } else{
    //       quest.map(x=>{
    //         if(assetval){
    //           x.value = assetval[x.key] ? assetval[x.key]: '';

    //           if(x.model){
    //             x.modelInfo.key = assetval.model
    //           }
    //         }
    //       })
    //       const z =[...quest]
    //       console.log('assetval2',z)
    //       return  z
    //     }

    //   }),tap(x=>console.log('switchmap',x)))
    // }), tap(x=>console.log('tapx2',x))
    ,switchMap(questions=>{
      console.log(console.log('options0',questions))
      const observables$ =[]
      for (const q of questions) {
        if(q.model){
          if(q.modelInfo.link.length){
            console.log('options01',questions)
           const model =  this.fb.getCollectionWhereFB(q.modelInfo.link,'key',q.modelInfo.key).pipe(map(m=>{
             if(m.length){

               return {
                 key:q.modelInfo.key,
                 model:m[0]
               }
             }
            
           }));
           observables$.push(model)
          }
        }
        if(q.optionsLink){
          console.log('options1',q.optionsLink)
        const option = this.fb.getCollectionFB(q.optionsLink).pipe(map(collection=>{
          const options={
            key:q.key,
            options:collection.map((x:any)=>{
              let opts
              if(x.cod_sede){
              opts ={
                key:x.cod_sede,
                value:x.nombre
              }
              } else{
                opts ={
                  key:x.key,
                  value:x.value
                }
              }
              return opts
            })   
          }
          console.log('options2',options)
          return options  
        }))
        observables$.push(option)
        }
        
        
      }
      if(!observables$.length){
        observables$.push(of(1))
      }
      console.log('observablesarray',observables$)
      return combineLatest(observables$).pipe(map((z:any)=>{
        console.log('options3',z,questions)
        const  zFilter = z.filter(z => z !==undefined);
        if(z[0]!==1){
           for (const element of zFilter) {
             const result = questions.find( ({ key }) => key === element.key );
             if(element.options){
               result.options = element.options
             }
             if(element.model){
               console.log('entro a modificar en base modelo',element.model)
               if(element.model.formQuestions){
                 if(element.model.formQuestions.length){
                   for (const quest of element.model.formQuestions) {
                     console.log('resultadoss2',quest,element.model)
                     if(quest.errors){
                       let obj = questions.find(ques => ques.key === quest.key);
                       obj.errors = quest.errors
                       obj.validators = quest.validators
                     }
                   }
                 }
   
               }
             }
           }

        }
        return questions
      }))
    }), tap(x=>console.log('tapx2',x)))
  }
}